import { EAuthNavigation } from '@hts/shared/enums';
import { Suspense, lazy } from 'react';
import { Route } from 'react-router';

const AccountPage = lazy(() => import('@hts/pages/AccountPage'));

export const AuthNavigator = (
  <>
    <Route
      path={EAuthNavigation.ACCOUNT}
      element={
        <Suspense>
          <AccountPage />
        </Suspense>
      }
    />
  </>
);
